/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgentSummary {
    getFixupPrototypeFunction() { return VirtualMachineAgentSummary.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgentSummary>): VirtualMachineAgentSummary {
        let obj = Object.assign(new VirtualMachineAgentSummary(), model);
        VirtualMachineAgentSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgentSummary>): VirtualMachineAgentSummary {
        if (!model) return null;
        return VirtualMachineAgentSummary.newInstance(<VirtualMachineAgentSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgentSummary) {
        if (!obj) return;

        models.VirtualMachineAgentSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgentSummary): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgentSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.launch_time === "string") {
            this.launch_time = new Date(<string><any>this.launch_time);
        }
        if (this.vm_agents_status) {
            for (let val of this.vm_agents_status) {
                models.VirtualMachineAgent.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource Id
     */
    sys_id: string;

    /**
     * Corestack service account id
     */
    service_account_id: string;

    service_resource_inventory_id: string;

    /**
     * Virtual machine id
     */
    instance_id: string;

    /**
     * Virtual machine name
     */
    resource_name: string;

    /**
     * List of VM agent statuses
     */
    vm_agents_status: Array<models.VirtualMachineAgent>;

    /**
     * Virtual machine type
     */
    instance_type: string;

    /**
     * Virtual machine state
     */
    instance_state: string;

    /**
     * Virtual machine region
     */
    region: string;

    /**
     * Virtual machine launch time
     */
    launch_time: Date;

    /**
     * Virtual Machine OS Type
     */
    os_type: string;

    /**
     * Virtual machine tags
     */
    tags: string;

    /**
     * Private dns name
     */
    host_name: string;

    /**
     * ssm ping status
     */
    ssm_ping_successful: boolean;

}
